// @flow
import type {
  ComposeDataTableArgs,
  ActionTypes,
  Action,
  ActionCreator,
} from '../../types'

function createAction<P> (type: string): ActionCreator<P> {
  return function (payload: P): Action<P> {
    return {
      type,
      payload,
    }
  }
}

// Exports
export default function composeActionTypes ({
  name,
  options,
  actionTypes,
  }: ComposeDataTableArgs & { actionTypes: ActionTypes }): {[string]: ActionCreator<any> } {
  //
  const {
    allowGrouping = false,
    allowColumnOrdering = false,
    allowSelecting = true,
    allowSorting = true,
    allowFiltering = true,
    allowPagination = true,
    allowSelectAll = true,
  } = options

  const actions = {}

  if (allowPagination) {
    const paginate: ActionCreator<number> = createAction(actionTypes.paginate)
    actions.paginate = paginate
  }

  if (allowSorting) {
    const sort: ActionCreator<{column: string}> = createAction(actionTypes.sort)
    actions.sort = sort
  }

  if (allowGrouping) {
    const group: ActionCreator<{column: string}> = createAction(actionTypes.group)
    actions.group = group
  }

  if (allowFiltering) {
    const filter: ActionCreator<{column: string, value: string}> = createAction(actionTypes.filter)
    actions.filter = filter
  }

  if (allowSelecting) {
    const select: ActionCreator<Array<number>> = createAction(actionTypes.select)
    actions.select = select
  }

  if (allowColumnOrdering) {
    const order: ActionCreator<{column: string, index: number}> = createAction(actionTypes.order)
    actions.order = order
  }

  if (allowSelectAll) {
    const selectAll: ActionCreator<> = createAction(actionTypes.selectAll)
    actions.selectAll = selectAll
  }

  const resetDataTableState: ActionCreator<> = createAction(actionTypes.resetDataTableState)
  actions.resetDataTableState = resetDataTableState

  return actions
}
